import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  EstatePlanningWorkflowReview = 'EstatePlanningWorkflowReview',
}

export const queryKeys = {
  estatePlanningWorkflowReview: (clientId: string) => [
    QueryFeature.Workflow,
    QueryKey.EstatePlanningWorkflowReview,
    clientId,
  ],
};
